<template>
  <article class="profile-drawer-user">
    <avatar :user="user" :border="false" class="header-avatar mr-3" />

    <div class="profile-drawer-user__info mr-3">
      <span class="profile-drawer-user__name">{{ getUserName }}</span>
      <a class="profile-drawer-user__logout" @click="logout">
        <v-icon color="#E92663" size="20">
          mdi-logout-variant
        </v-icon>
        выйти
      </a>
    </div>

    <v-icon
      color="#DBDFE6"
      x-large
      @click="hideProfileDrawer"
    >
      mdi-close-circle-outline
    </v-icon>
  </article>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'ProfileDrawerUser',
    components: { Avatar },
    computed: {
      ...mapState({
        user: (state) => state.auth.user || {},
      }),
      getUserName () {
        return this.user ? this.user.name : '–'
      },
    },
    methods: {
      hideProfileDrawer () {
        this.$store.commit('app/hideProfileDrawer')
      },
      logout () {
        this.$store.dispatch('auth/logout').then(() => {
          window.location.href = '/login'
        })
      },
    },
  }
</script>

<style scoped lang="less">
.profile-drawer-user {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__info {
    // имя длиннее шторки не должно распирать строку с крестиком
    min-width: 0;
  }

  &__name {
    display: block;
  }

  &__logout {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;
    color: #e92663;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
